<template>
    <v-row>
    <v-col>
      <v-card
          style="width: 100%;
    height: calc(100vh - 87px);
    display: flex;
    flex-direction: column;
    min-height: 0;"
          class="flex-grow-1 overflow-y-auto pa-4">
      <v-calendar
        ref="calendar"
        v-model="focus"
        color="blue"
        :weekday-format="myDayFormat"
        :month-format="myMonthFormate"
        :events="events"
        :event-color="getEventColor"
        :event-ripple="false"
        :type="currentMode.startsWith('5') ? 'week' : currentMode"
        :class="{'five-week': currentMode === '5week'}"
        interval-height="20"
        :interval-count="24*4"
        :interval-minutes="15"
        :interval-format="myIntervalFormat"
        :weekdays="weekdayOrder"
        event-more-text="Mehr anzeigen"
        @click:more=""
    >
      <template v-slot:day-label-header="{day, present, month, year, weekday}">
        <v-row class="m-0" style="margin-top: -6px !important;">
          <v-col v-if="!isSelected(year, month, day)" md="3" class="p-1"><v-btn
              fab  x-small depressed
              @click="selectedDay = new Date(year, month-1, day, 12).toISOString().substring(0, 10); selectDay()">{{day}}</v-btn></v-col>
          <v-col v-else md="3" class="p-1"><v-btn fab  x-small depressed color="#63c2de">{{day}}</v-btn></v-col>
          <v-col v-if="(weekday + 6) % 7 < userDays.length" class="p-1 text-right">
            <v-chip
                :class="{'soll-ist':true, 'zero': !isFuture(day, present, month, year), 'undefined': isFuture(day, present, month, year)}"
                label small
                v-if="userDays[(weekday + 6) % 7].user_day.soll === 0.0"
            >
              Soll: {{userDays[(weekday + 6) % 7].user_day.soll}} Ist: {{roundToDigits(userDays[(weekday + 6) % 7].user_day.ist, 2)}}
            </v-chip>
            <v-chip
                label
                small
                :class="{'soll-ist': true, 'neg': !isFuture(day, present, month, year), 'undefined': isFuture(day, present, month, year)}"
                v-else-if="userDays[(weekday + 6) % 7].user_day.soll > userDays[(weekday + 6) % 7].user_day.ist"
            >
              Soll: {{userDays[(weekday + 6) % 7].user_day.soll}} Ist: {{roundToDigits(userDays[(weekday + 6) % 7].user_day.ist, 2)}}
            </v-chip>
            <v-chip
                label
                small
                class="soll-ist pos"
                v-else
            >
              Soll: {{userDays[(weekday + 6) % 7].user_day.soll}} Ist: {{roundToDigits(userDays[(weekday + 6) % 7].user_day.ist, 2)}}
            </v-chip>
          </v-col>
        </v-row>
      </template>
      <template v-slot:event="{ event, timed, eventSummary, day}" >
        <div  :class="[event.id !== 'created' ? 'clickable' : '', 'v-event-draggable']" @click="selectedDay = new Date(day.year, day.month-1, day.day, 12).toISOString().substring(0, 10); selectDay()">
          <!--component :is="{ render: eventSummary }"></component-->
          <div class="v-event-summary" style="color: white">
            <v-row v-if="event.task !== event.name" style="margin: 0; flex-grow: 0">
              <v-icon small :color="'white'" style="align-items: start; padding-top: 2px;"
                      v-text="'mdi-clipboard-check'">
              </v-icon>
              <v-col cols="10" class="p-0">
                <p :class="{'mb-0': true,  'ml-1': true, 'planned-for': true, 'event-description': true}"
                   :style="{'color': 'white'}">{{event.task}}</p>
              </v-col>
            </v-row>
            <v-row v-if="event.type === 'FEHL'" style="margin: 0; flex-grow: 0">
              <v-icon :color="'white'" style="align-items: start; padding-top: 0px;"
                      v-text="event.color === '#095996' ? 'mdi-umbrella-beach' : 'mdi-account-cancel'">
              </v-icon>
              <v-col cols="10" class="p-0">
                <p :class="{'mb-0': true,  'ml-1': true, 'planned-for': true, 'event-description': true}"
                   style="font-size: 16px; margin-bottom: 0px; padding-top: 1px"><b>{{event.name}}</b></p>
              </v-col>
            </v-row>
            <p v-if="event.task" style="margin-bottom: 2px; font-size: 16px"><b>{{event.name}}</b></p>
            <p v-if="event.description" style="margin-bottom: 2px">{{event.description}}</p>
          </div>
        </div>
      </template>
      <template v-slot:interval="{weekday, time}" >
        <div :style="{'background-color': getBackgroundColor((weekday + 6) % 7, time), 'height': '20px'}" style="color: white; font-weight: bold; padding-left: 8px" @click="log(e)">
          {{getRbName((weekday + 6) % 7, time)}}
        </div>
        <div style="display: none" v-if="(weekday + 6) % 7 < userDays.length">{{userDays[(weekday + 6) % 7].user_day.soll}}</div>
      </template>
    </v-calendar>
      </v-card>
    </v-col>
    <v-col cols="3">
      <v-card
          style="width: 100%;
    height: calc(100vh - 87px);" class="overflow-y-auto overflow-x-hidden">
        <v-list-item two-line>
          <v-list-item-content>
            <v-list-item-title class="text-h5">
              Details: {{displayDate}}
            </v-list-item-title>
            <v-list-item-subtitle>{{displayMita}}</v-list-item-subtitle>
            <v-btn
                block
                tile
                color="success"
                v-if="this.currentMita"
                style="height: 40px;
                margin-top: 8px;
                          border-radius: 14px;
                          color: white !important; width: 200px; min-width: 200px !important; float: right"
                v-on:click="goToUserDay"
            >
              <v-icon left>
                mdi-open-in-new
              </v-icon>
              Tag anzeigen
            </v-btn>
          </v-list-item-content>
        </v-list-item>
        <v-divider style="margin-top: 8px"></v-divider>
        <v-row>
          <v-col style="padding-top: 0px; padding-bottom: 0px">
            <v-card-title style="padding: 6px; font-size: 1rem; padding-left: 12px">
              Zulagen
            </v-card-title>
            <v-divider style="margin: 0"></v-divider>
            <v-data-table
                :headers="headers_surcharges"
                :items="items_surcharges"
                hide-default-footer
                disable-pagination
                disable-sort
                style="max-height: 22vh; min-height: 22vh; overflow-y: auto"
            ></v-data-table>
            <v-divider style="margin: 0"></v-divider>
          </v-col>
        </v-row>
        <v-row>
          <v-col style="padding-top: 0px; padding-bottom: 0px">
            <v-card-title style="padding: 6px; font-size: 1rem; padding-left: 12px">
              Fahrzeuge und Geräte
            </v-card-title>
            <v-divider style="margin: 0"></v-divider>
            <v-data-table
                :headers="headers_fahrs"
                :items="items_fahrs"
                hide-default-footer
                disable-pagination
                disable-sort
                style="max-height: 22vh; min-height: 22vh; overflow-y: auto"
            ></v-data-table>
            <v-divider style="margin: 0"></v-divider>
          </v-col>
        </v-row>
        <v-row>
          <v-col style="padding-top: 0px; padding-bottom: 0px">
            <v-card-title style="padding: 6px; font-size: 1rem; padding-left: 12px">
              Material
            </v-card-title>
            <v-divider style="margin: 0"></v-divider>
            <v-data-table
                :headers="headers_artis"
                :items="items_artis"
                hide-default-footer
                disable-pagination
                disable-sort
                style="max-height: 22vh; min-height: 22vh; overflow-y: auto"
            ></v-data-table>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
    </v-row>
</template>

<script>
import {Redirect_500, Redirect_Login, Server_URL_ZK} from "@/shared/utils";

export default {
  name: "AuskunftWeek",
  props: {
    date: {
      type: String,
      default () {
        return new Date().toISOString().substr(0, 10);
      }
    },
    currentMode: {
      type: String,
      default () {
        return "week";
      }
    },
    currentMita: {
      type: String,
      default: () => undefined
    },
    showLoader: {
      type: Function,
      default: undefined
    },
    hideLoader: {
      type: Function,
      default: undefined
    },
    mitasFlat: {
      type: Array,
      default: () => []
    },
    holidayLohn: {
      type: String,
      default: ""
    }
  },
  mounted() {
    console.log("mounted")
    // check if the current date is a sunday if so adjust the date to the next monday
    if (this.focus) {
      let currentDate = new Date(this.focus);
      if (currentDate.getDay() === 0) {
        currentDate.setDate(currentDate.getDate() + 1);
        this.focus = currentDate.toISOString().substr(0, 10);
      }
    }
    this.$refs.calendar.updateTimes();
    this.currentMonth = this.$refs.calendar.parsedValue.month;
    this.currentYear = this.$refs.calendar.parsedValue.year;
    this.$refs.calendar.scrollToTime('06:45')
    let currentDate = new Date(this.date);
    let day = currentDate.getDay();
    this.start = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() - day + 1, 12);
    this.end = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() + (7 - day), 12);
    this.selectedDay = this.start.toISOString().substr(0, 10);
    if (this.currentMita) {
      this.queryData()
    } else {
      this.events = [];
      this.userDays = [];
    }
  },
  watch: {
    date: function (newDate) {
      if (newDate) {
        let currentDate = new Date(newDate);
        if (currentDate.getDay() === 0) {
          currentDate.setDate(currentDate.getDate() + 1);
          newDate = currentDate;
        }
      }
      this.focus = newDate;
      this.$nextTick(() => {
        this.currentMonth = this.$refs.calendar.parsedValue.month;
        this.currentYear = this.$refs.calendar.parsedValue.year;
        let currentDate = new Date(this.date);
        let day = currentDate.getDay();
        this.start = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() - day + 1, 12);
        this.end = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() + (7 - day), 12);
        this.selectedDay = this.start.toISOString().substr(0, 10);
        if (this.currentMita) {
          this.queryData()
        } else {
          this.events = [];
          this.userDays = [];
        }
      });
    },
    currentMita: function (newDate) {
      if (this.currentMita) {
        this.queryData()
      } else {
        this.events = [];
        this.userDays = [];
      }
    },
  },
  computed: {
    displayMita() {
      let mita = this.getCurrentMita(this.currentMita);
      return mita ? mita.name : "Keine Mitarbeiter ausgewählt";
    },
    displayDate() {
      return this.selectedDay ? this.selectedDay.split("-").reverse().join(".") : '';
    },
  },
  data: () => ({
    focus: new Date().toISOString().substr(0, 10),
    weekdayOrder: [1, 2, 3, 4, 5, 6, 0],
    weekdays: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
    months: ["","Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
    monthsLong: ["","Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
    events: [],
    userDays: [],
    currentMonth: 0,
    currentYear: 0,
    start: null,
    end: null,
    selectedDay: "",
    headers_surcharges: [
      { text: 'Von', value: 'von', sortable: false,},
      { text: 'Bis', value: 'bis', sortable: false,},
      { text: 'Zulage', value: 'name', sortable: false,},
    ],
    headers_fahrs: [
      { text: 'Von', value: 'von', sortable: false,},
      { text: 'Bis', value: 'bis', sortable: false,},
      { text: 'Fahrzeug', value: 'title', sortable: false,},
    ],
    headers_artis: [
      { text: 'Menge', value: 'std', sortable: false,},
      { text: 'Material', value: 'title', sortable: false,},
    ],
    items_surcharges: [],
    items_fahrs: [],
    items_artis: [],
  }),
  methods: {
    goToUserDay() {
      this.$router.push("/zeitkontrolle/zeiterfassung?user="+this.currentMita+'&date=' + this.selectedDay.split('T')[0]);
    },
    log(e) {
      console.log(e)
    },
    selectDay() {
      let surs = [];
      let fahrs = [];
      let artis = [];
      for (let i = 0; i < this.userDays.length; i++) {
        if (this.userDays[i].user_day.date === this.selectedDay) {
          let current = this.userDays[i];
          surs = current.surcharges;
          for (let j = 0; j < current.time_blocks.length; j++) {
            for (let k = 0; k < current.time_blocks[j].children.length; k++) {
              if (current.time_blocks[j].children[k].type === 'FAGE') {
                fahrs.push(current.time_blocks[j].children[k]);
              } else if (current.time_blocks[j].children[k].type === 'ARTI') {
                artis.push(current.time_blocks[j].children[k]);
              }
            }
          }
          break;
        }
      }
      this.items_surcharges = surs;
      this.items_fahrs = fahrs;
      this.items_artis = artis;
    },
    isSelected(year, month, day) {
      return this.selectedDay === new Date(year, month-1, day, 12).toISOString().substring(0, 10);
    },
    queryData(){
      let mita = this.getCurrentMita(this.currentMita);
      this.showLoader();
      this.$http.get(
          Server_URL_ZK + '/zk/overview_week/' + mita.bis_id + "?start=" + this.start.toISOString().substring(0, 10) + "&end=" + this.end.toISOString().substring(0, 10)
      ).then(this.responseOkGetOverview, this.responseError)
    },
    getCurrentMita(id) {
      for (let i = 0; i < this.mitasFlat.length; i++) {
        if (this.mitasFlat[i].id === id) {
          return this.mitasFlat[i];
        }
      }
      return null;
    },
    myIntervalFormat({time}) {
      if (time.substring(3) === "00") {
        return time
      }
      return ""
    },
    myDayFormat(d) {
      return this.weekdays[d.weekday]
    },
    myMonthFormate(d) {
      return this.months[d.month]
    },
    getEventColor (event) {
      const rgb = parseInt(event.color.substring(1), 16)
      const r = (rgb >> 16) & 0xFF
      const g = (rgb >> 8) & 0xFF
      const b = (rgb >> 0) & 0xFF

      return event === this.createEventTimeLine
          ? `rgba(${r}, ${g}, ${b}, 0.7)`
          : event === this.createEvent
              ? `rgba(${r}, ${g}, ${b}, 0.7)`
              : `rgba(${r}, ${g}, ${b}, 0.9)`
    },
    isFuture(day, present, month, year) {
      if (present) {
        return false
      }
      let today = new Date();
      today = new Date(today.getFullYear(), today.getMonth(), today.getDate());
      let date = new Date(year, month-1, day);
      return date > today;
    },
    roundToDigits (number, digits) {
      const roundTo = Math.pow(10, digits)
      return Math.round(number * roundTo) / roundTo
    },
    responseOkGetOverview(response) {
      this.hideLoader();
      if (response.status === 200) {
        this.userDays = response.body.overviews;
        console.log(response.body);
        this.calculateEvents();
        this.selectDay();
      } else {
        window.location = Redirect_500;
      }
    },
    responseError(response) {
      this.hideLoader();
      if (response.status === 401) {
        window.location = Redirect_Login;
      } else {
        window.location = Redirect_500;
      }
    },
    calculateEvents() {
      let events = [];
      for (let i = 0; i < this.userDays.length; i++) {
        let current = this.userDays[i].time_blocks;
        let e = null;
        let eF = null;
        for (let j = 0; j < current.length; j++) {
          let split = current[j];
          console.log(split)
          if (true) {
            let start = new Date(`${this.userDays[i].user_day.date}T${split.von}:00`)
            let end = new Date(`${this.userDays[i].user_day.date}T${split.bis}:00`)
            let name = split.title;
            let description = split.legr;
            let task = split.type === "ARBL" ?  split.task : "";
            let holidayOverwrite = split.task === this.holidayLohn;
            let color = "#000";
            switch (split.type) {
              case "ARBL":
                color = "#328f33";
                if (e != null) {
                  events.push(e);
                  e = null;
                }
                if (eF != null) {
                  events.push(eF);
                  eF = null;
                }
                events.push({
                  id: split.id,
                  name: name,
                  task: task,
                  description: description,
                  start: start,
                  end: end,
                  color: color,
                  type: "ARBL",
                  timed: true,
                })
                break;
              case "PAUS":
                color = "#a6a4a4";
                events.push({
                  id: split.id,
                  name: "Pause",
                  task: "Pause",
                  description: '',
                  start: start,
                  end: end,
                  color: color,
                  timed: true,
                })
                break;
              case "FEHL":
                color = "#ea5324"
                  if (holidayOverwrite) {
                    color = "#095996";
                  }
                if (e != null) {
                  events.push(e);
                  e = null;
                }
                if (eF != null && eF.name === name) {
                  eF.end = end;

                } else if (eF != null) {
                  events.push(eF);
                  eF = null;
                } else {
                  eF = {
                    id: split.id,
                    name: name,
                    start: start,
                    end: end,
                    color: color,
                    type: "FEHL",
                    timed: true,
                  }
                }
                break;
            }
          }
        }
        if (e != null) {
          events.push(e);
          e = null;
        }
        if (eF != null) {
          events.push(eF);
          eF = null;
        }
      }
      this.events = events;
    },
    getBackgroundColor(index, start) {
      let color = 'rgba(232,232,232,0.37)'
      if (this.userDays.length) {
        try {
          let splits = this.userDays[index].user_time.soll_zeit.split("-");
          let rbTopLevelSplits = this.userDays[index].rb.split("; ");
          for (let i = 0; i < rbTopLevelSplits.length; i++) {
            let rbSplits = rbTopLevelSplits[i].split(" - ");
            if (rbSplits[0] <= start && (rbSplits[1] > start || rbSplits[1] === "00:00")) {
              console.log("found split in " + rbTopLevelSplits)
              return 'rgba(255,188,10,0.79)';
            }
          }
          if (splits[0] <= start && splits[1] > start) {
            color = '#fff'
          }
        } catch (e) {
          console.log(e)
        }
      } else {
        color = '#fff'
      }
      return color
    },
    getRbName(index, start) {
      let name = ''
      if (this.userDays.length) {
        try {
          let rbTopLevelSplits = this.userDays[index].rb.split("; ");
          for (let i = 0; i < rbTopLevelSplits.length; i++) {
            let rbSplits = rbTopLevelSplits[i].split(" - ");
            if (rbSplits[0] === start) {
              return 'RB ' + rbTopLevelSplits[i];
            }
          }
        } catch (e) {
          console.log(e)
        }
      }
      return name
    },
  },
}
</script>

<style scoped>
.v-calendar .v-event {
  pointer-events: none;
}

.clickable-month {
  pointer-events: auto !important;
  padding-left: 4px;
  padding-right: 4px;
}

.clickable {
  pointer-events: auto !important;
  padding: 6px;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.theme--light.v-label {
  color: black;
}


.v-calendar-weekly__head-weekday {
  color: black !important;
  background-color: #e4e5e6 !important;
}

.theme--light.v-calendar-weekly .v-calendar-weekly__day.v-outside {
  margin-right: -1px;
}

::v-deep .v-event-timed {
  margin-left: 4px;
  margin-right: 4px;
  width: calc(100% - 8px) !important;
}


::v-deep .five-week div.v-calendar-daily_head-day:nth-child(7) {
  display: none;
  height: 0px !important;
  width: 0px !important;
}

::v-deep .five-week div.v-calendar-daily_head-day:nth-child(8) {
  display: none;
  height: 0px !important;
  width: 0px !important;
}

::v-deep .five-week div.v-calendar-daily__day:nth-child(7) {
  display: none;
  height: 0px !important;
  width: 0px !important;
}

::v-deep .five-week div.v-calendar-daily__day:nth-child(8) {
  display: none;
  height: 0px !important;
  width: 0px !important;
}

::v-deep .v-calendar .v-btn--fab.v-size--default {
  width: 28px;
  height: 28px;
}

::v-deep .v-calendar .v-btn--fab.v-size--default.blue {
  background-color: rgb(99, 194, 222) !important;
  border-color: rgb(99, 194, 222) !important;
}

::v-deep .v-calendar-daily__pane {
  min-height: 100% !important;
}

.event-description {
  flex: 0 0 auto;
  overflow: hidden;
  width: 100%;
  white-space: normal;
  word-break: normal;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  margin-bottom: 2px;
}

.planned-for {
  margin-top: 1px;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: normal;
}

.event-extended {
  flex: 0 0 auto;
  margin-bottom: 4px
}

::v-deep .v-list-group__header__prepend-icon {
  margin-right: 0px  !important;
  margin-top: 6px  !important;
}

::v-deep .v-list-group--no-action > .v-list-group__items > .v-list-item {
  padding-left: 18px !important;
}

.unselectable-text {
  -webkit-user-select: none !important; /* Safari */
  -moz-user-select: none !important; /* Firefox */
  -ms-user-select: none !important; /* IE10+/Edge */
  user-select: none !important; /* Standard */
}

::v-deep .v-calendar .v-event-timed-container {
  margin: 2px !important;
}

.rounded {
  border-radius: 8px !important;
}

.rounded::before {
  border-radius: 8px !important;
}

</style>
